import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _CloseProcessCycle, _ProcessCycle } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { InputDate } from "../../../theme/Input/InputDate";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";


export const ProcessCycle = () => {

    const ProcessCycle = useDataBean(_ProcessCycle);
    const CloseProcessCycle = useDataBean(_CloseProcessCycle);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [processType, setprocessType] = useState<number>(null)
    const [lastDate, setlastDate] = useState<number>(null)
    const [modalcierre, setModalcierre] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        ProcessCycle.instance.getProcessCyclesFrom(processType, lastDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const closeProcessPeriod = () => {

        CloseProcessCycle.instance.closeProcessPeriod(CloseProcessCycle.bean.Year, CloseProcessCycle.bean.Month, CloseProcessCycle.bean.ProcessType, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Cierre Mensual Creado');
                    setModalcierre({ ...modalcierre, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        ProcessCycle.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ProcessCycle.instance.deleteProcessCycle(ProcessCycle.bean.IDProcessCycle).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        ProcessCycle.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verbymob = () => {
        setModalcierre({ ...modalcierre, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDProcessCycle', visible: true },
        { title: 'Nombre', property: 'CycleName', visible: true },
        { title: 'Fecha de Cierre', property: 'LastDate', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${ProcessCycle.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Cierre de Procesos">
            <div className="row">
                <div className="col-md-4">
                    <SelectProccessTypeConstants label='Tipo de Proceso' idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                    seleccione un Tipo de Proceso*
                </div>
                <div className="col-md-4">
                    <InputDate notDate label="Fecha a consultar" name="InitDate" value={lastDate} setDate={(e) => { setlastDate(e) }} />
                    seleccione una Fecha*
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-search-line" clase="primary" eventClick={getLista} disable={processType == null || lastDate == null}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={verbymob}>
                        Crear Cierre Mensual
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ProcessCycle.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modalcierre} updateModal={setModalcierre} eventModal={closeProcessPeriod}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProccessTypeConstants label='Tipo de Proceso' idSelector={CloseProcessCycle.bean.ProcessType} onChange={(e) => CloseProcessCycle.setBean({ ...CloseProcessCycle.bean, "ProcessType": e })} />
                            </div>
                            <div className="col-md-6">
                                <YearSelector value={CloseProcessCycle.bean.Year} tittle="Año" onChange={(e) => CloseProcessCycle.setBean({ ...CloseProcessCycle.bean, "Year": e })} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor idSelect={CloseProcessCycle.bean.Month} onChange={(e) => CloseProcessCycle.setBean({ ...CloseProcessCycle.bean, "Month": e })} label="Mes" name="" />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ProcessCycle.bean.CycleName}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}